import React from 'react';
import { FormattedMessage } from 'react-intl';
import _ from 'lodash';
import { Tabs } from 'antd';
import styles from './EnhancedCandidate360SecondaryInfoSection.module.scss';
import CandidateSkillsSection from '../CandidateCard/CandidateCardQualificationsSummary/CandidateSkillsSection';
import CandidateEducationSection from '../CandidateCard/CandidateCardQualificationsSummary/CandidateEducationSection';
import CandidateCardMetaData from '../CandidateCard/CandidateCardMetaData/CandidateCardMetaData';
import CandidateTagsContainer from '../../Containers/CandidateTags/CandidateTagsContainer';
import { logSmartKarrotEvent } from '../../Analytics/EventUtils';
import { getCandidateMetadataActionEventName } from '../../Analytics/Candidate/CandidateEventUtils';
import { modules } from '../../Analytics/EventTypes';
import message from '../../Containers/CandidateDrawer/messages';

const { TabPane } = Tabs;

function EnhancedCandidate360SecondaryInfoSection(props) {
  const {
    activeSourceName,
    activeTab,
    candidate = {},
    candidateContext,
    candidateDetailsStatus,
    isDiversityAttributesVisible,
    jobId,
    keywordsToHighlight,
    mustHavesKeywords,
  } = props;
  const [activeSecondaryInfoTab, setSecondaryActiveInfoTab] = React.useState('candidate-skills');

  const candidateSkills = candidate.Skills;
  const candidateEducation = candidate.Educations;
  const candidateKeywords =
    activeTab === 'sourced' && activeSourceName !== 'AryaRecommended' ? [] : candidate.Keywords || [];
  const combinedKeywordsToHighlight = _.uniq([...(keywordsToHighlight || []), ...(candidateKeywords || [])]);

  const onTabChange = activeKey => {
    setSecondaryActiveInfoTab(activeKey);
    logSmartKarrotEvent(getCandidateMetadataActionEventName(activeKey), {
      Module: modules.candidate.candidateActions,
    });
  };

  const candidateTagStyle = { maxHeight: '150px', overflow: 'auto' };
  const secondaryInfoStyle = { padding: '0px 10px', maxHeight: '150px', overflow: 'auto' };

  return (
    <div className={styles.enhanced360SecondaryInfo}>
      <Tabs
        defaultActiveKey="candidate-skills"
        onChange={onTabChange}
        activeKey={activeSecondaryInfoTab}
        className={styles.candidate360SecondaryTabs}
      >
        <TabPane tab={<FormattedMessage {...message.candidateSkills} />} key="candidate-skills">
          {candidateSkills?.length ? (
            <CandidateSkillsSection
              skills={candidateSkills}
              candidate={candidate}
              keywordsToHighlight={keywordsToHighlight}
              combinedKeywordsToHighlight={combinedKeywordsToHighlight}
              mustHavesKeywords={mustHavesKeywords}
              secondaryInfoStyle={secondaryInfoStyle}
              keywordHighlightKey=""
              shouldShowTooltip={false}
              tooltipPlacement="bottom"
            />
          ) : (
            <div className={styles.emptyTabScreenMessage}>
              <FormattedMessage {...message.noDataFound} />
            </div>
          )}
        </TabPane>
        <TabPane tab={<FormattedMessage {...message.candidateEducation} />} key="candidate-education">
          {candidateEducation?.length ? (
            <CandidateEducationSection
              candidateEducation={candidateEducation}
              secondaryInfoStyle={secondaryInfoStyle}
              shouldShowTooltip={false}
            />
          ) : (
            <div className={styles.emptyTabScreenMessage}>
              <FormattedMessage {...message.noDataFound} />
            </div>
          )}
        </TabPane>
        <TabPane tab={<FormattedMessage {...message.othersLabel} />} key="candidate-metadata">
          <CandidateCardMetaData
            candidate={candidate}
            isDiversityAttributesVisible={isDiversityAttributesVisible}
            secondaryInfoStyle={{ padding: '0px 10px' }}
          />
        </TabPane>
        <TabPane tab={<FormattedMessage {...message.candidateTags} />} key="candidate-tags">
          <CandidateTagsContainer
            candidate={candidate}
            candidateContext={candidateContext}
            candidateDetailsStatus={candidateDetailsStatus}
            jobId={jobId}
            candidateTagStyle={candidateTagStyle}
          />
        </TabPane>
      </Tabs>
    </div>
  );
}

export default EnhancedCandidate360SecondaryInfoSection;
